import React from 'react';
const ProductDefinition: React.FC = () => (
  <section className="border-y border-[#b8c5bc] bg-[#f5f7f5] py-14 md:py-16" aria-labelledby="que-es-certy">
    <div className="max-w-[1240px] mx-auto px-5 sm:px-8 lg:px-10 grid lg:grid-cols-[0.68fr_1.32fr] gap-9 lg:gap-16">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-[#15783a] font-semibold mb-5">Qué es Certy</p>
        <p className="text-sm leading-6 text-[#526158]">Windows · Aplicación de escritorio · Licencia por dispositivo</p>
      </div>
      <div>
        <h2 id="que-es-certy" className="text-3xl md:text-5xl leading-[1] tracking-[-0.045em] font-semibold">Una forma más clara de trabajar con certificados digitales.</h2>
        <p className="max-w-3xl mt-6 text-lg leading-8 text-[#3d5145]">Certy reúne los certificados instalados en Windows, muestra su vigencia y permite abrir portales oficiales con la identidad correcta. Está pensado para equipos que gestionan certificados de varias personas o empresas.</p>
        <div className="mt-8 grid gap-4 border-t border-[#c9d2cc] pt-6 text-sm font-semibold text-[#34463b] sm:grid-cols-3">
          <p>Detecta los certificados del equipo.</p>
          <p>Separa cada identidad por pestaña.</p>
          <p>Centraliza vigencia, firma y avisos.</p>
        </div>
      </div>
    </div>
  </section>
);

export default ProductDefinition;
